const List = () => import("@/pages/master/customer-power-and-group/List")
const Form = () => import("@/pages/master/customer-power-and-group/Form")
// import List from '@/pages/master/customer-power-and-group/List'
// import Form from '@/pages/master/customer-power-and-group/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/master/customer-power-and-group",
    name: "customer-power-and-group-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Customer Power and Group" },
        { title: "List", active: true }
      ],
      title: "Customer Power and Group List",
      module: "Customer Power and Group",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/customer-power-and-group/create",
    name: "customer-power-and-group-create",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Customer Power and Group" },
        { title: "Create", active: true }
      ],
      title: "Customer Power and Group Create",
      module: "Customer Power and Group",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/customer-power-and-group/view/:id",
    name: "customer-power-and-group-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Customer Power and Group" },
        { title: "View", active: true }
      ],
      title: "Customer Power and Group View",
      module: "Customer Power and Group",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/customer-power-and-group/edit/:id",
    name: "customer-power-and-group-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Customer Power and Group" },
        { title: "Edit", active: true }
      ],
      title: "Customer Power and Group Edit",
      module: "Customer Power and Group",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
